import { render } from "./FooterSegment.vue?vue&type=template&id=526e317f&scoped=true"
const script = {}

import "./FooterSegment.vue?vue&type=style&index=0&id=526e317f&scoped=true&lang=css"

import exportComponent from "/home/carlos/dev/libre-sube/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526e317f"]])

export default __exports__